import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import Loading from "./Loading";

export default function ProtectedRoute({ children }) {
  const { user, ready } = useAuth();
  if (!ready) return <Loading message="AUTHENTICATING" />;
  // Send unauth visitors to the public news feed; the AUTHENTICATE
  // button in the nav is the discoverable path back to /auth for those
  // who explicitly want to sign in. This makes logout redirect race-immune.
  if (!user) return <Navigate to="/news" replace />;
  return children;
}
